import React,{useState} from 'react';
import {
    CardGroup,
    Card,
    // CardImg,
    CardBody,
    CardTitle,
    CardSubtitle,
    CardText,

} from 'reactstrap';
// import ButtonEdit from '../../common/Buttons/ButtonEdit';
// import ButtonDelete from '../../common/Buttons/ButtonDelete';
const ElementTypeCard=(props)=>
{
  const[redirectionForm,setRedirectionForm]=useState(`${props.formRedirection}?id=${props.rowpos}`) 
  const handleOpen=()=>{props.getElementType(props.id)}
    return(
<CardGroup className='crdGrpType tracking-in-expand-fwd-top'>
  <Card className='crdBody'>
  <div className='' >
    {/* onClick={e=>{handleOpen(e)}} */}
    <CardBody className='myshadowcardType'>
      {/* <CardTitle tag="h5">
      {props.id}
      </CardTitle> */}
      <CardSubtitle
        className="mb-2 text-white mytitle"
        tag="h5"
      >
       {props.name}
      </CardSubtitle>
     
      <CardText className='text-start'>
      <a href="#"> {props.val}</a>
      </CardText>
      {/* <ButtonEdit btnTitle="Edit" href={redirectionForm}/>
      <ButtonDelete btnTitle="Delete"usehtmlFor="head"rowpos={props.rowpos}onDelete={props.onDelete}/> */}
    </CardBody>
    </div>
  </Card>
</CardGroup>
    )
}
export default ElementTypeCard;